<template>
    <div class="sidebar__section sidebar__section--vertical-padding sidebar__section--border-bottom" v-if="showAddAsBase">
        <div class="poi-add-base">
            <div class="copy-light poi-add-base__description">
                Legen Sie Ihren persönlichen Stützpunkt als „Mein Stützpunkt“ fest. Dieser steht Ihnen dann in unseren Services zur Verfügung, wo Sie ihn gerade benötigen.
            </div>
            <SmrButton :color="oeamtcBaseActive ? 'green' : 'grey'" :loading="loading" @click.native="addMyOeamtcBaseClickHandler">
                <template v-if="oeamtcBaseActive">Mein Stützpunkt</template>
                <template v-else>Als „Mein Stützpunkt“ festlegen</template>
            </SmrButton>
        </div>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import { mapGetters } from 'vuex';
import SmrButton from '@/components/SmrButton.vue'
export default {
    components: {
        SmrButton
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters(['myOeamtcBase', 'user']), 
        showAddAsBase() {
            return this.poi.category === 'BASE';
        },
        oeamtcBaseActive() {
            return this.myOeamtcBase === this.poi.id;
        },
        
    },
    mounted() {
        if(this.user && this.myOeamtcBase === false) {
            this.getMyOeamtcBase();
        }
    },
    methods: {
        addMyOeamtcBaseClickHandler() {
            if(this.user) {
                if(this.oeamtcBaseActive) {
                    this.removeMyOeamtcBase();
                } else {
                    this.addMyOeamtcBase();
                }
            } else {
                eventBus.$emit('showLoginMenu')  
            }
        },
        getMyOeamtcBase() {
            this.$store.dispatch('getMyOeamtcBase');
        },
        async addMyOeamtcBase() {
            this.loading = true;
            await this.$store.dispatch('addMyOeamtcBase', this.poi.id);
            this.loading = false;
        },
        async removeMyOeamtcBase() {
            this.loading = true;
            await this.$store.dispatch('removeMyOeamtcBase');
            this.loading = false;
        },
    }
}
</script>

<style lang="scss">
.poi-add-base {
    &__description {
        &:not(:last-child) {
            margin-bottom: 24px;
        }
    }
}
</style>